import { defineEntityContract, type EntityStateEvents, type QueuedChangeFailureEvents } from 'shared/channels/entity';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import type { VisibleFieldModel, VisibleFieldsEditModel } from './visibleFieldModel';

export type VisibleFieldsEditRequest = {
  visibleFieldsEdit: VisibleFieldsEditModel;
  uniqueId: string;
};

/**
 * Visible field events. Outcome payloads stay `unknown`: the HTTP queue sends
 * `true` after a save and `{ error, messageId }` with a failure.
 */
export type VisibleFieldEvents = EntityStateEvents & QueuedChangeFailureEvents & {
  [DomainMessagesTypes.allVisibleFields]: { hasAll?: boolean; items: VisibleFieldModel[] };
  [DomainMessagesTypes.uploadedEntity]: unknown;
};

/** An edit resolves once queued; its outcome follows as an event with its `uniqueId`. */
export type VisibleFieldRequests = {
  edit: { request: VisibleFieldsEditRequest; response: void };
};

/** Fields shown in each process of the selected project. */
export const visibleFieldContract = defineEntityContract<VisibleFieldModel, VisibleFieldEvents, VisibleFieldRequests>(
  'visibleFieldChannel',
  { collectionEvent: DomainMessagesTypes.allVisibleFields }
);
